var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercardSmall = function SvgMastercardSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "#000",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M12.963 4a3.793 3.793 0 0 1 3.785 3.8c0 2.098-1.695 3.8-3.785 3.8a3.76 3.76 0 0 1-2.456-.91 3.76 3.76 0 0 1-2.455.91 3.793 3.793 0 0 1-3.786-3.8C4.266 5.7 5.96 4 8.052 4c.937 0 1.794.343 2.455.91A3.76 3.76 0 0 1 12.963 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M12.963 4a3.793 3.793 0 0 1 3.785 3.8c0 2.098-1.695 3.8-3.785 3.8a3.76 3.76 0 0 1-2.456-.91 3.8 3.8 0 0 0 1.33-2.89 3.8 3.8 0 0 0-1.33-2.89A3.76 3.76 0 0 1 12.963 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M10.507 4.909a3.8 3.8 0 0 1 1.33 2.891 3.8 3.8 0 0 1-1.33 2.89 3.8 3.8 0 0 1-1.33-2.89c0-1.158.516-2.194 1.33-2.891"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercardSmall);
export default ForwardRef;